// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import { fetchApiData, roundPrice, getSupplierInfo } from '../../../fnc.js'
import {
	NavLink
} from 'react-router-dom';
import store from 'store2';
import Loading from '../../ctn/Loading';
 
const refConst = require("../../../constants.js").v

export default function PMAFromSelection(props){

	const refDaysBackCapture = useRef(null);
	const initialState = {
		freeFreightPerSupplierId: [],
	}

	const [poList, setPoList] = useState(null);
	const [supplierFilter, setSupplierFilter] = useState(() => store("reordering.supplierFilter") ?? 'All');
	const [lockedFilter, setLockedFilter] = useState(() => store("reordering.lockedFilter") ?? 'All');
	const [searchText, setSearchText] = useState(() => store("reordering.searchText") ?? '');
	const [freeFreightPerSupplierId, setFreeFreightPerSupplierId] = useState(initialState.freeFreightPerSupplierId);
	const [coverageDays, setCoverageDays] = useState(14);
	const [bufferPercent, setBufferPercent] = useState(10);
	const [spikeThreshold, setSpikeThreshold] = useState(1.5);
	const [atLeastXSalePerMonth, setAtLeastXSalePerMonth] = useState(1);
	const [supplierOverrides, setSupplierOverrides] = useState([]);

	// const refTitle = useRef(null)

	// Get unique supplier names for the filter dropdown
	const supplierOptions = useMemo(() => {
		if (!Array.isArray(poList)) return [];
		const names = poList.map(po => po.supplier_name || po.id_supplier).filter(Boolean);
		names.sort();
		return ['All', ...Array.from(new Set(names))];
	}, [poList]);

	// Supplier ID list for overrides select
	const supplierIdOptions = useMemo(() => {
		if (!Array.isArray(poList)) return [];
		const idToName = new Map();
		poList.forEach(po => {
			const id = po.id_supplier;
			if(id !== undefined && id !== null && !idToName.has(id)){
				idToName.set(id, po.supplier_name || id);
			}
		});
		return Array.from(idToName, ([id, name]) => ({ id, name }));
	}, [poList]);

	// Refetch PO list when lockedFilter changes
	useEffect(() => {
		fetchPoList();
	}, [lockedFilter]);

	// Filtered PO list
	const filteredPoList = useMemo(() => {
		if (!Array.isArray(poList)) return [];

		let list = poList;

		// Apply supplier dropdown filter first
		if (supplierFilter !== 'All') {
			list = list.filter(po => (po.supplier_name || po.id_supplier) === supplierFilter);
		}

		// Apply text search filter (supplier name or supplier id)
		if (searchText.trim() !== '') {
			const q = searchText.trim().toLowerCase();
			list = list.filter(po => {
				const name = (po.supplier_name || '').toString().toLowerCase();
				const id = (po.id_supplier ?? '').toString().toLowerCase();
				return name.includes(q) || id.includes(q);
			});
		}

		return list;
	}, [poList, supplierFilter, searchText]);

	// Reset filter if current filter is not in the options
	useEffect(() => {
		if (!supplierOptions.includes(supplierFilter)) {
			setSupplierFilter('All');
		}
	}, [supplierOptions, supplierFilter]);

	useEffect(() => {
		fetchPoList();
		fetchFreeFreightPerSupplierId();
	}, [])

	function toDecimalPercent(val){
		let num = parseFloat(val);
		if(isNaN(num)) return 0;
		return num > 1 ? (num/100) : num;
	}

	function buildOptions(){
		let overrides = {};
		supplierOverrides.forEach((row) => {
			if(!row) return;
			const sid = parseInt(row.supplierId, 10);
			if(!isNaN(sid)){
				const cDays = parseInt(row.coverageDays, 10);
				const bPercent = toDecimalPercent(row.bufferPercent);
				overrides[sid] = {};
				if(!isNaN(cDays)) overrides[sid].coverageDays = cDays;
				if(!isNaN(bPercent)) overrides[sid].bufferPercent = bPercent;
			}
		});

		return {
			coverageDays: Math.max(1, parseInt(coverageDays, 10) || 14),
			bufferPercent: toDecimalPercent(bufferPercent),
			spikeThreshold: Math.max(1, parseFloat(spikeThreshold) || 1.5),
			atLeastXSalePerMonth: Math.max(0, parseInt(atLeastXSalePerMonth, 10) || 0),
			supplierOverrides: overrides,
		};
	}

	function submitSupplierOverride(row){
		if(!row) return;
		const sid = parseInt(row.supplierId, 10);
		if(isNaN(sid)) return;

		const payload = {};
		const cDays = parseInt(row.coverageDays, 10);
		const bPercent = toDecimalPercent(row.bufferPercent);
		if(!isNaN(cDays)) payload.coverageDays = cDays;
		if(!isNaN(bPercent)) payload.bufferPercent = bPercent;

		props.loading(true);
		fetchApiData(
			"finale",
			"add_supplier_info",
			{
				id_supplier: sid,
				reorder_json: JSON.stringify(payload)
			},
			null,
			(r) => {
				console.info('submitSupplierOverride', r);
				props.loading(false);
				if(r && r.success && props.info){
					props.info({success: `Override saved for supplier ${sid}`});
				}
			}
		)
	}

	function prefillSupplierOverrideFromInfo(supplierId){
		const sid = parseInt(supplierId, 10);
		if(isNaN(sid)) return;
		getSupplierInfo({ is_supplier_list: JSON.stringify([sid]) }, (r) => {
			if(r && r.success && Array.isArray(r.data) && r.data.length > 0){
				const match = r.data.find(info => parseInt((info.id_supplier ?? info.id), 10) === sid);
				if(!match) return;
				let parsed = {};
				try{
					parsed = (match.reorder_json !== undefined && match.reorder_json !== null) ? JSON.parse(match.reorder_json) : {};
				}catch(e){ parsed = {}; }
				setSupplierOverrides(prev => {
					return prev.map(row => {
						if(parseInt(row.supplierId, 10) === sid){
							return Object.assign({}, row, {
								coverageDays: parsed?.coverageDays ?? row.coverageDays,
								bufferPercent: (parsed?.bufferPercent !== undefined && parsed?.bufferPercent !== null)? (parseFloat(parsed?.bufferPercent) * 100) : row.bufferPercent
							});
						}
						return row;
					});
				});
			}
		});
	}

	// Preload overrides for all suppliers present in the current PO list
	useEffect(() => {
		if(!poList || poList.length === 0) return;
		const uniqueSupplierIds = Array.from(new Set(poList.map(po => po.id_supplier).filter(id => id !== undefined && id !== null)));
		if(uniqueSupplierIds.length === 0) return;
		getSupplierInfo({ is_supplier_list: uniqueSupplierIds.join(',') }, (r) => {
			if(!(r && r.success)) return;
			const byId = new Map();
			if(Array.isArray(r.data)){
				r.data.forEach(info => {
					const sid = parseInt((info.id_supplier ?? info.id), 10);
					if(!isNaN(sid)) byId.set(String(sid), info);
				});
			}
			setSupplierOverrides(() => {
				let next = [];
				uniqueSupplierIds.forEach(sid => {
					const info = byId.get(String(parseInt(sid, 10)));
					let parsed = null;
					let shouldAdd = false;
					if(info && info.reorder_json !== undefined && info.reorder_json !== null){
						try{ parsed = JSON.parse(info.reorder_json) }catch(e){ parsed = null }
						if(parsed && typeof parsed === 'object'){
							if(parsed.coverageDays !== undefined || parsed.bufferPercent !== undefined || parsed.spikeThreshold !== undefined){
								shouldAdd = true;
							}
						}
					}
					/* if(sid == 18){
						alert(JSON.stringify(info))
					} */
					if(shouldAdd){
						next.push({
							supplierId: sid,
							coverageDays: parsed?.coverageDays ?? '',
							bufferPercent: (parsed?.bufferPercent !== undefined && parsed?.bufferPercent !== null)? (parseFloat(parsed?.bufferPercent) * 100) : ''
						});
					}
				});
				return next;
			});
		});
	}, [poList])

	function clearSupplierOverride(row){
		if(!row) return;
		const sid = parseInt(row.supplierId, 10);
		if(isNaN(sid)) return;
		props.loading(true);
		fetchApiData(
			"finale",
			"add_supplier_info",
			{
				id_supplier: sid,
				reorder_json: JSON.stringify(null)
			},
			null,
			(r) => {
				props.loading(false);
				if(r && r.success){
					if(props.info) props.info({success: `Override cleared for supplier ${sid}`});
					setSupplierOverrides(prev => prev.filter(o => parseInt(o.supplierId, 10) !== sid));
				}
			}
		)
	}

	function refreshRecommendations(){
		props.loading(true); 
		fetchApiData(
			"reordering",
			"daily_capture_v2",
			{
				"daysBackCapture": refDaysBackCapture.current.value,
				options: JSON.stringify(buildOptions())
			},
			null,
			(r) => {
				console.info("fetch_daily_capture_v2_with_options", r);
				props.loading(false);
				fetchPoList();
			}
		)
	}

	function fetchPoList(){
		fetchApiData(
			"reordering",
			"getReorderRecommendations", {
				/* filters: JSON.stringify({
					locked: lockedFilter === 'All' ? null : (lockedFilter === 'Locked'),
				}) */
				// options will be passed explicitly when using the Refresh button
			},
			null,
			(r) => {
				console.info("fetch_poList", r);

				// API may return undefined/null on error; always store an array once loaded
				setPoList(Array.isArray(r?.data) ? r.data : []);
			}
		)
	}

	function fetchFreeFreightPerSupplierId(){
		fetchApiData(
			"reordering",
			"getFreeFreightPerSupplierId",
			{},
			null,
			(data) => {
				console.info("getFreeFreightPerSupplierId", data);
				setFreeFreightPerSupplierId(data);
			}
		)
	}

	let countSection = 4;
	if(props.lineAccess && props.lineAccess.from !== null)
		countSection = 3;

	console.info("poList", poList);

	return (
		<div className="">
			<div className="row">
				<div className="col-12 shadow rounded border m-3 p-3">
					<h2>Filters:</h2>
					<div className="mb-3 mt-3" style={{maxWidth: 600, display: 'flex', gap: 16}}>
						<label htmlFor="supplierFilter" className="mr-2 font-weight-bold">
							Supplier:
							<i 
								className="bi bi-info-circle ml-1 tooltipInfo"
								data-toggle="tooltip"
								title="Filter the purchase order list by a specific supplier. Select 'All' to show purchase orders from all suppliers."
								data-html="true"
							></i>
						</label>
						<select
							id="supplierFilter"
							className="form-control d-inline-block"
							style={{width: 'auto', display: 'inline-block'}}
							value={supplierFilter}
							onChange={e => { setSupplierFilter(e.target.value); store("reordering.supplierFilter", e.target.value); }}
						>
							{supplierOptions.map(opt => (
								<option key={opt} value={opt}>{opt}</option>
							))}
						</select>
						<label htmlFor="lockedFilter" className="ml-3 mr-2 font-weight-bold">
							Status:
							<i 
								className="bi bi-info-circle ml-1 tooltipInfo"
								data-toggle="tooltip"
								title="Filter by purchase order status. 'Locked' means the order has been finalized and cannot be modified. 'Unlocked' orders can still be edited. 'All' shows both locked and unlocked orders."
								data-html="true"
							></i>
						</label>
						<select
							id="lockedFilter"
							className="form-control d-inline-block"
							style={{width: 'auto', display: 'inline-block'}}
							value={lockedFilter}
							onChange={e => { setLockedFilter(e.target.value); store("reordering.lockedFilter", e.target.value); }}
						>
							<option value="All">All</option>
							<option value="Locked">Locked</option>
							<option value="Unlocked">Unlocked</option>
						</select>
						<label htmlFor="daysBackCapture" className="ml-3 mr-2 font-weight-bold">
							Days back capture:
							<i 
								className="bi bi-info-circle ml-1 tooltipInfo"
								data-toggle="tooltip"
								title="Number of days to look back when analyzing sales history for reorder recommendations. This determines how much historical sales data is used to calculate average daily/monthly sales. Higher values provide more stable averages but may be less responsive to recent trends."
								data-html="true"
							></i>
						</label>
						<input
							id="daysBackCapture"
							type="number"
							min={1}
							max={730}
							className="form-control d-inline-block"
							style={{width: 'auto', display: 'inline-block'}}
							defaultValue={store("reordering.daysBackCapture") ?? 30}
							ref={refDaysBackCapture}
							onChange={e => { store("reordering.daysBackCapture", e.target.value); }}
						/>
					</div>
					<div className="mb-3 p-3 border rounded">
						<div className="font-weight-bold mb-2">Reorder Options</div>
						<div className="d-flex align-items-center flex-wrap" style={{gap: 16}}>
							<label htmlFor="coverageDays" className="mr-2">
								Coverage Days:
								<i 
									className="bi bi-info-circle ml-1 tooltipInfo"
									data-toggle="tooltip"
									title="Target number of future days to cover. The system calculates the target stock, then subtracts current remaining stock and stock already on order."
									data-html="true"
								></i>
							</label>
							<input
								id="coverageDays"
								type="number"
								min={1}
								max={180}
								className="form-control d-inline-block"
								style={{width: 120}}
								value={coverageDays}
								onChange={e => setCoverageDays(e.target.value)}
							/>

							<label htmlFor="bufferPercent" className="ml-3 mr-2">
								Buffer Percent (%):
								<i 
									className="bi bi-info-circle ml-1 tooltipInfo"
									data-toggle="tooltip"
									title="Safety margin added on top of coverage days calculation to account for unexpected demand spikes or supply delays. Enter as a percentage (e.g., 10 = 10%, 15 = 15%). Example: With 100 units needed for coverage and 10% buffer, you'll order 110 units total. Can be set to zero if you do not want to order extra items as buffer."
									data-html="true"
								></i>
							</label>
							<input
								id="bufferPercent"
								type="number"
								min={0}
								step="0.1"
								className="form-control d-inline-block"
								style={{width: 140}}
								value={bufferPercent}
								onChange={e => setBufferPercent(e.target.value)}
							/>

							<label htmlFor="spikeThreshold" className="ml-3 mr-2">
								Spike Threshold:
								<i 
									className="bi bi-info-circle ml-1 tooltipInfo"
									data-toggle="tooltip"
									title="Multiplier used to flag unusual monthly sales spikes for manual review. It does not increase the recommendation. Lower values are more sensitive; higher values only flag larger spikes."
									data-html="true"
								></i>
							</label>
							<input
								id="spikeThreshold"
								type="number"
								min={1}
								step="0.1"
								className="form-control d-inline-block"
								style={{width: 140}}
								value={spikeThreshold}
								onChange={e => setSpikeThreshold(e.target.value)}
							/>

							<label htmlFor="atLeastXSalePerMonth" className="ml-3 mr-2">
								At least X sale/month:
								<i 
									className="bi bi-info-circle ml-1 tooltipInfo"
									data-toggle="tooltip"
									title="Minimum average monthly unit sales over the selected lookback period. Set to 0 to include all sold items."
									data-html="true"
								></i>
							</label>
							<input
								id="atLeastXSalePerMonth"
								type="number"
								min={0}
								step="1"
								className="form-control d-inline-block"
								style={{width: 140}}
								value={atLeastXSalePerMonth}
								onChange={e => setAtLeastXSalePerMonth(e.target.value)}
							/>
						</div>

						<div className="mt-3">
							<div className="d-flex align-items-center justify-content-between mb-2">
								<div className="font-weight-bold">Supplier Overrides</div>
								<button className="btn btn-sm btn-outline-primary" onClick={() => setSupplierOverrides(prev => [...prev, {supplierId: '', coverageDays: '', bufferPercent: ''}])}>+ Add override</button>
							</div>
							<table className="table table-sm">
								<thead>
									<tr>
										<th style={{width: 160}}>Supplier ID</th>
										<th style={{width: 160}}>Coverage Days</th>
										<th style={{width: 180}}>Buffer Percent (%)</th>
										<th style={{width: 80}}></th>
									</tr>
								</thead>
								<tbody>
									{supplierOverrides.length === 0 && (
										<tr><td colSpan={4} className="text-center text-muted">No overrides. Click &quot;+ Add override&quot; to add one.</td></tr>
									)}
									{supplierOverrides.map((row, idx) => (
										<tr key={idx}>
										<td>
											<select
												className="form-control"
												value={row.supplierId}
												onChange={e => {
													const val = e.target.value;
													setSupplierOverrides(prev => prev.map((r, i) => i === idx ? Object.assign({}, r, {supplierId: val}) : r));
													// Prefill from server; do not submit on supplier change
													setTimeout(() => prefillSupplierOverrideFromInfo(val), 0);
												}}
											>
												<option value="">Select supplier...</option>
												{supplierIdOptions.map(opt => (
													<option key={opt.id} value={opt.id}>{`${opt.name}`} ({opt.id})</option>
												))}
											</select>
										</td>
											<td>
												<input
													type="number"
													min={1}
													className="form-control"
													value={row.coverageDays}
												onChange={e => {
													const val = e.target.value;
													setSupplierOverrides(prev => prev.map((r, i) => i === idx ? Object.assign({}, r, {coverageDays: val}) : r));
													setTimeout(() => submitSupplierOverride(Object.assign({}, row, {coverageDays: val})), 0);
												}}
												/>
											</td>
											<td>
												<input
													type="number"
													min={0}
													step="0.1"
													className="form-control"
													value={row.bufferPercent}
												onChange={e => {
													const val = e.target.value;
													setSupplierOverrides(prev => prev.map((r, i) => i === idx ? Object.assign({}, r, {bufferPercent: val}) : r));
													setTimeout(() => submitSupplierOverride(Object.assign({}, row, {bufferPercent: val})), 0);
												}}
												/>
											</td>
											<td className="text-right">
												<div className="btn-group">
													<button className="btn btn-sm btn-outline-secondary" onClick={() => clearSupplierOverride(row)}>Clear</button>
													<button className="btn btn-sm btn-outline-danger" onClick={() => setSupplierOverrides(prev => prev.filter((_, i) => i !== idx))}>Remove</button>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
					<div className="text-center m-3">
						<button className="btn btn-primary" onClick={refreshRecommendations} disabled={props.loading()}>
							Refresh recommendations
						</button>
					</div>
				</div>
				{
					filteredPoList.length > 0 && (
						<div className="col-12">
								<table className="table table-striped">
									<thead>
										<tr>
											<th colSpan={9}>
											<input
													type="text"
													className="form-control"
													placeholder="Search by Supplier name or ID"
												value={searchText}
												onChange={e => { setSearchText(e.target.value); store("reordering.searchText", e.target.value); }}
												/>
											</th>
										</tr>
									<tr>
										<th>Supplier ID</th>
										<th>Supplier</th>
										<th className="text-wrap text-center align-middle">Count Items</th>
										<th className="text-wrap text-center align-middle">AVG Daily Sales</th>
										<th className="text-wrap text-center align-middle">AVG Monthly Sales</th>
										<th className="text-wrap text-center align-middle">Total Reordering Cost</th>
										<th className="text-wrap text-center align-middle">Reached Free Freight</th>
										<th className="text-wrap text-center align-middle">Status</th>
										<th className="text-wrap text-center align-middle">Locked Info</th>
									</tr>
								</thead>
								<tbody>
									{filteredPoList.map((po) => {

										let reachedFreeFreight = false;
										if(freeFreightPerSupplierId[po.id_supplier]?.freeFreight > 0 && freeFreightPerSupplierId[po.id_supplier]?.freeFreight <= po.total_reordering_cost)
											reachedFreeFreight = true;
										let hasFreeFreight = freeFreightPerSupplierId[po.id_supplier]?.freeFreight > 0;
										
										return <tr key={po.id} style={{cursor: 'pointer'}}/*  onClick={(e) => {
												e.preventDefault();
												props.parent.history.push(`/Reordering/${po.id}`)
											}} */>
												<td>{po.id_supplier}</td>
												<td onClick={(e) => {
													e.preventDefault();
													props.parent.history.push(`/Reordering/${po.id_supplier}`)
												}}><div className="pointer border align-middle text-center">{po.supplier_name || po.id_supplier}</div>
												{/* {
													<PoShowListItems
														{...props}
														title={po.supplier_name || po.id_supplier}
														data={po}
														fetchPoList={fetchPoList}
													/>
												} */}
												</td>
												<td className="text-center align-middle">{po.total_sku}</td>
												<td className="text-center align-middle">{po.total_qty_avg_daily_sales}</td>
												<td className="text-center align-middle">{po.total_qty_avg_monthly_sales}</td>
												<td className="text-center align-middle" /* Total Reordering Cost */>${roundPrice(po.total_reordering_cost, 2)}</td>
												<td className="text-center align-middle tooltipInfo" data-toggle="tooltip" title={`Free Freight: ${hasFreeFreight ? freeFreightPerSupplierId[po.id_supplier]?.freeFreight : 'N/A'} - Total Cost: ${po.total_reordering_cost}`}>
													<span className={`badge badge-${reachedFreeFreight? 'success' : (hasFreeFreight ? 'danger' : 'secondary')}`}>
														{hasFreeFreight ? (reachedFreeFreight ? 'Yes' : 'No') : 'N/A'}
													</span>
												</td>
												<td className="text-center align-middle">
													<span className={`badge badge-${po.locked ? 'warning' : 'success'}`}>
														{po.locked ? 'Locked' : 'Unlocked'}
													</span>
												</td>
												<td className="text-center align-middle">
													{
														po.locked? <>
															<div>Locked by: {po.uid_validator}</div>
															<div>{po.date_locked ? new Date(po.date_locked).toLocaleDateString() : ''}</div>
															<div>From: {po.data_firebase?.email}</div>
														</> : 
														<div> - </div>
													}
												</td>
											</tr>
									})}	
								</tbody>
							</table>
						</div>
					)
				}
				{
					filteredPoList.length === 0 && poList !== null && (<div className="col-12">
						<div className="alert alert-info text-center">No POs found</div>
					</div>)
				}
			</div>
		</div>
	);
}
